import { Injectable, WritableSignal, inject, signal } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Device, DeviceInfo } from "@capacitor/device";
import { NavigationBar } from "@hugotomazi/capacitor-navigation-bar";
import { StatusBar } from "@capacitor/status-bar";

@Injectable({ providedIn: "root" })
export class DeviceInfoService {
	private platform = inject(Platform);
	private readonly LARGE_SCREEN_WIDTH_THRESHOLD = 1200;
	isAndroid: WritableSignal<boolean> = signal(false);
	isMobile: WritableSignal<boolean> = signal(false);

	constructor() {
		this.getPlatformInfo();
		this.getDeviceType();
	}

	async getPlatformInfo(): Promise<string> {
		if (typeof window === "undefined") {
			return "unknown";
		}

		const screenWidth = window.innerWidth;

		if (screenWidth >= this.LARGE_SCREEN_WIDTH_THRESHOLD) {
			return "web";
		}

		if (this.platform.is("capacitor")) {
			const info: DeviceInfo = await Device.getInfo();
			if (info.platform === "android") {
				this.isAndroid.set(true);
			}
			return info.platform;
		} else {
			if (this.platform.is("ios")) return "ios";
			if (this.platform.is("android")) {
				this.isAndroid.set(true);
				return "android";
			}
			if (this.platform.is("pwa")) return "pwa";
			if (this.platform.is("electron")) return "electron";
			if (this.platform.is("mobileweb")) return "mobileweb";
			if (this.platform.is("desktop")) return "desktop";
			return "unknown";
		}
	}

	getDeviceType() {
		this.isMobile.set(
			this.platform.is("ios") ||
				this.platform.is("android") ||
				this.platform.is("mobileweb") ||
				window.innerWidth < 768
				? true
				: false
		);
	}

	showNavAndStatusBar() {
		NavigationBar.show();
		StatusBar.show();
		// NavigationBar.setTransparency({ isTransparent: true });
		// NavigationBar.setColor({
		// 	color: "#00000000",
		// 	darkButtons: false
		// });
	}

	hideNavAndStatusBar() {
		NavigationBar.hide();
		StatusBar.hide();
	}
}
